<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qnOMLh/tc-custom/9781504082723.jpg?1704252159513" alt="This image is the cover for the book Supernatural Noir"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Supernatural Noir
      </h1>
      <p class="bookDescription body article font2">
        <b>Sixteen tales that combine the otherworldly with hardboiled crime fiction—from Joe R. Lansdale, Caitlín R. Kiernan, Paul G. Tremblay, Melanie Tem, and others.</b><br/><br/> Here are the femme fatales, the tough guys, the down-on-their-luck detectives—but with a twist. Collected by Hugo and Bram Stoker Award–winning editor Ellen Datlow, these stories of the murderous and macabre will take you onto the dark streets of worlds unlike our own, where the monstrous stalk their prey.<br/><br/> At the behest of a beautiful blonde client, a small-town East Texas private eye is drawn into a case of grave robbing by someone—or something—with an unholy interest in “Dead Sister” by Joe R. Lansdale. Elizabeth Bear’s “The Romance” takes partygoers on a wild ride when the centerpiece of a birthday celebration turns out to be a haunted merry-go-round. After robbing a pawnshop, a group of small-time crooks get their shocking comeuppance as they flee the scene in “The Getaway” by Paul G. Tremblay. “Little Shit” by Melanie Tem follows a college student with a very unique skill set as she makes money on the side taking down criminals.<br/><br/><i>Supernatural Noir</i> also includes bone-chilling tales from Lucius Shepard, Laird Barron, Brian Evenson, Gregory Frost, Richard Bowes, Jeffrey Ford, Lee Thomas, Tom Piccirilli, Nate Southard, Nick Mamatas, and John Langan.<br/><br/> “This anthology has some of the most exciting fiction published in 2011. This is fiction that will make you uncomfortable, that will haunt you, that will show up in your dreams. . . . Horrifyingly wonderful.” —<i>Fantasy Literature</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Datlow, Gregory Frost, Paul G. Tremblay, Richard Bowes, Melanie Tem, Lucius Shepard, Jeffrey Ford, Laird Barron, Elizabeth Bear, Joe R. Lansdale, Lee Thomas, Tom Piccirilli, Nate Southard, Brian Evenson, Caitlín R. Kiernan, Nick Mamatas, John Langan
      </h2>
      
      <p class="authorDescription body article">Ellen Datlow, an acclaimed science fiction and fantasy editor, was born and raised in New York City. She has been a short story and book editor for more than thirty years and has edited or coedited several critically acclaimed anthologies of speculative fiction, including the Year&rsquo;s Best Fantasy and Horror series and <I>Black Thorn, White Rose </I>(1994) with Terri Windling. Datlow has received numerous honors, including multiple Shirley Jackson, Bram Stoker, Hugo, Locus, and World Fantasy Awards, and Life Achievement Awards from the&#160;Horror Writers Association and the World Fantasy Association, to name just a few. She resides in New York. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?859f5df8